import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Table, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import TransferenciaEstadoService from '../../services/transferenciasEstado'
import Transferencia from './transferencia';
import '../../styles/diario.scss';

const ListarTransferencias = () => {

    const ITEMS_PER_PAGE = 20;

    const [transferencias, setTransferencias] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [periodo, setPeriodo] = useState({ inicio: 'Janeiro/2015', fim: new Date().toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }) });

    async function fetchTransferencias() {
        const response = await TransferenciaEstadoService.catTrans({ tipo: "Voluntária" });
        if (response.data.length >= 1) {
            setTransferencias(response.data)
            setVazio(false)
        } else {
            setTransferencias([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchTransferencias();
    }, []);

    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
    const currentTransfer = transferencias.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const calcularTotal = () => {
        return transferencias.reduce((acc, t) => acc + parseFloat(t.valor || 0), 0);
    }

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setTransferencias={setTransferencias}
                    setVazio={setVazio}
                    setPeriodo={setPeriodo}
                    fetchTransferencias={fetchTransferencias}
                    transferencias={transferencias}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <br />
                    <h5>Transferências voluntárias realizadas pelo Estado do Rio de Janeiro para o Município de Macuco</h5>
                    <br />
                    <Fragment>
                        <div className="resumo-transferencias mb-3">
                            <strong>Total Recebido:</strong> {calcularTotal().toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            <br />
                            <strong>Período:</strong> {periodo.inicio} até {periodo.fim}
                        </div>
                    </Fragment>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th><h5>Origem</h5></th>
                                <th><h5>Mês</h5></th>
                                <th><h5>Ano</h5></th>
                                <th><h5>Valor</h5></th>
                                <th><h5>Tipo</h5></th>
                                <th><h5>Programa</h5></th>
                                <th><h5>Destinatário</h5></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentTransfer.map((transfer, index) =>
                                <Transferencia
                                    transfer={transfer}
                                    key={index}
                                />
                            )}
                        </tbody>
                    </Table>
                    {/* Paginação */}
                    <ul className='pagination'>
                        {Array.from({ length: Math.ceil(transferencias.length / ITEMS_PER_PAGE) }, (_, i) => (
                            <li key={i} className='page-item'>
                                <button onClick={() => paginate(i + 1)} className='page-link'>
                                    {i + 1}
                                </button>
                            </li>
                        ))}
                    </ul>
                </Fragment>}
        </Fragment>

    )
}

export default ListarTransferencias;